(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    class JpLpoAccessibility extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.product-details');
      if (!root) return;
      const updateLabels = () => {
        const controls = Array.from(root.querySelectorAll('.cl-po--option select.cl-po--input'));
        const dimension = (control) => control.name.match(/^properties\[(_?(width|length))_(m|cm)(?:_(\d+))?\]$/);
        const label = (control) => Array.from(control.labels ?? []).map((item) => item.textContent.trim()).join(' ').trim();
        for (const control of controls) {
          const parts = dimension(control);
          if (!parts || parts[3] !== 'cm' || label(control) || control.getAttribute('aria-label')?.trim() || control.hasAttribute('aria-labelledby')) continue;
          const partners = controls.filter((item) => {
            const other = dimension(item);
            return other && other[1] === parts[1] && other[3] === 'm' && label(item);
          });
          const exact = partners.filter((item) => dimension(item)[4] === parts[4]);
          const candidates = exact.length ? exact : partners.filter((item) => !dimension(item)[4]);
          const partner = candidates.length === 1 && (exact.length || partners.length === 1) ? candidates[0] : undefined;
          if (partner) control.setAttribute('aria-label', `${label(partner)}の端数`);
        }
      };
      this.observer = new MutationObserver(updateLabels);
      this.observer.observe(root, { childList: true, subtree: true, characterData: true });
      updateLabels();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('jp-lpo-accessibility')) {
    customElements.define('jp-lpo-accessibility', JpLpoAccessibility);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jp-product-purchase-mode"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-purchase-mode')) {
    customElements.define('jp-purchase-mode', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a[data-product-id]');
          if (!link || link.hasAttribute('aria-current')) return;
          const choices = JSON.parse(this.querySelector('[data-purchase-choices]').textContent);
          const choice = choices.find(item => item.id === link.dataset.productId);
          if (!choice) return;
          const names = JSON.parse(this.dataset.optionNames);
          const picker = this.closest('.shopify-section').querySelector('variant-picker');
          if (!picker) return;
          const values = [];
          for (const option of picker.querySelectorAll('.variant-option')) {
            const control = option.querySelector('input:checked, select');
            const selected = control?.tagName === 'SELECT' ? control.selectedOptions[0] : control;
            const position = Number(selected?.dataset.inputId?.split('-')[0]);
            if (Number.isInteger(position) && position > 0 && position <= names.length) {
              values[position - 1] = control.value;
            }
          }
          const variant = choice.variants.find(item => item.options.every((value, i) => value === values[names.indexOf(choice.options[i])]));
          const url = new URL(choice.url, location.origin);
          if (url.origin !== location.origin || !/^\/(products\/|products_preview)/.test(url.pathname)) return;
          url.searchParams.set('variant', (variant || choice.variants[0]).id);
          link.href = url.href;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jp-wishlist-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-wishlist-button')) {
    customElements.define('jp-wishlist-button', class extends HTMLElement {
      connectedCallback() {
        this.details = this.closest('.product-details');
        if (!this.details) return;

        this.moveButton = () => {
          const injectedBar = this.details.querySelector('add-to-cart-component .swym-button-bar');
          if (injectedBar && injectedBar.parentElement !== this) {
            this.replaceChildren(injectedBar);
          }

          const button = this.querySelector('.swym-add-to-wishlist');
          if (!button) return;

          if (this.button !== button) {
            this.buttonObserver?.disconnect();
            this.button = button;
            this.buttonObserver = new MutationObserver(this.updateLabels.bind(this));
            this.buttonObserver.observe(button, { attributes: true, attributeFilter: ['class', 'aria-pressed'] });
          }

          this.updateLabels();
        };

        this.moveButton();
        this.observer = new MutationObserver(this.moveButton);
        this.observer.observe(this.details, { childList: true, subtree: true });
      }

      updateLabels() {
        const button = this.button;
        if (!button?.isConnected) return;

        const added = button.classList.contains('swym-added') || button.getAttribute('aria-pressed') === 'true';
        const label = added ? this.dataset.addedLabel : this.dataset.addLabel;
        const cta = button.querySelector('.swym-wishlist-cta');
        const tooltip = button.querySelector('.swym-tooltip-text');
        const viewLink = tooltip?.querySelector('.swym-open-ui');

        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
        if (cta && cta.textContent !== label) cta.textContent = label;

        if (viewLink) {
          const prefix = `${this.dataset.addedLabel}：`;
          const textNode = tooltip.firstChild;
          if (textNode?.nodeType === Node.TEXT_NODE && textNode.textContent !== prefix) {
            textNode.textContent = prefix;
          }
          if (viewLink.textContent !== this.dataset.viewLabel) viewLink.textContent = this.dataset.viewLabel;
        } else if (tooltip && tooltip.textContent !== label) {
          tooltip.textContent = label;
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.buttonObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
